<template>
  <div style="height: 100%;width: 100%">
    <div style="height: 110px;width: 100%">
      <div v-if="listData.length === 0" class="no-alarm"></div>
      <div v-if="listData.length === 0" class="no-alarm1">
        <span>暂无报警信息</span>
      </div>
      <el-row>
        <el-col :span="6" v-for="item in listData" :key="item.index">
          <div class="list-top-info">
            <div class="left-img">
<!--              <span v-if="item.pid !== 0">-->
<!--                <span v-if="item.person !== ''">-->
<!--                  <img v-if="item.person.photourl !== ''" :src="item.person.photourl">-->
<!--                  <img v-else src="../../../assets/SHscreen/index_information_people_head.png">-->
<!--                </span>-->
<!--                <img v-else src="../../../assets/SHscreen/index_information_people_head.png">-->
<!--              </span>-->
              <img src="../../../assets/SHscreen/index_information_home_head.png">
            </div>
            <div class="right-info">
              <div style="height: 3px"></div>
              <div style="height: 22px">
                <div class="icon-left">
                  <img src="../../../assets/SHscreen/index_information_icon_police.png">
                </div>
                <div class="text-right">
                  <span>{{getAlarmType(item.alarmtype)}}</span>
                </div>
              </div>
<!--              <div style="height: 18px" v-if="item.pid !== 0">-->
<!--                <div class="icon-left">-->
<!--                  <img src="../../../assets/SHscreen/index_information_icon_name.png">-->
<!--                </div>-->
<!--                <div class="text-right" :title="item.person.name">-->
<!--                  <span>{{item.person.name}}</span>-->
<!--                </div>-->
<!--              </div>-->
              <div style="height: 22px">
                <div class="icon-left">
                  <img src="../../../assets/SHscreen/index_information_icon_phone.png">
                </div>
                <div class="text-right" :title="item.phone">
                  <span>{{item.phone}}</span>
                </div>
              </div>
              <div style="height: 22px">
                <div class="icon-left">
                  <img src="../../../assets/SHscreen/index_information_icon_address.png">
                </div>
                <div class="text-right" style="white-space: nowrap" :title="getAddress(item)">
                  <span>{{getAddress(item)}}</span>
                </div>
<!--                <div v-else class="text-right" :title="item.person.homeaddress">-->
<!--                  <span>{{item.person.homeaddress}}</span>-->
<!--                </div>-->
              </div>
              <div style="height: 22px">
                <div class="icon-left">
                  <img src="../../../assets/SHscreen/index_information_icon_home.png">
                </div>
                <div class="text-right" :title="item.home_install_location">
                  <span>{{item.home_install_location}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: calc(100% - 150px);width: 100%;margin-top: 10px">
      <el-table ref="table"
                class="table-list"
                height="35px"
                :header-cell-style="getBackgroundColor"
                :row-class-name="tableRowClassName"
                :cellStyle="cellStyle"
                :data="tableData"
                style="width: 100%"
                size="mini">
        <el-table-column label="报警编号" width="75" :resizable="true"></el-table-column>
        <el-table-column label="事件类型" width="150" :resizable="true" align="left"></el-table-column>
        <el-table-column label="设备类型" width="150" align="left"></el-table-column>
        <el-table-column label="事件时间" width="135" align="left"></el-table-column>
        <el-table-column label="位置" min-width="140" align="left"></el-table-column>
        <el-table-column label="安装位置" min-width="80" align="left"></el-table-column>
      </el-table>
      <vue-seamless-scroll :data="tableData" :class-option="classOption" style="height: calc(100% - 35px);overflow: hidden">
        <el-table ref="table"
                  :show-header="false"
                  class="table-list"
                  :header-cell-style="getBackgroundColor"
                  :row-class-name="tableRowClassName"
                  :cellStyle="cellStyle"
                  :data="tableData"
                  style="width: 100%" size="mini">
          <el-table-column
            label="报警编号"
            width="75"
            :resizable="true"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <!--        <marquee scrollamount="3">{{scope.row.id}}</marquee>-->
              <span>{{scope.row.id}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="事件类型"
            width="150"
            :resizable="true"
            align="left">
            <template slot-scope="scope">
              <img style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImgAlarm(scope.row.alarmtype)">
              <span>{{getAlarmType(scope.row.alarmtype)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备类型" width="150" align="left">
            <template slot-scope="scope">
              <img v-if="scope.row.alarmtype !== 'birthday' || scope.row.alarmtype !== 'phonein'" style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImg(scope.row.device_type)">
              <span v-if="scope.row.alarmtype !== 'birthday' || scope.row.alarmtype !== 'phonein'">{{getDeviceType(scope.row.device_type)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="time"
            label="事件时间"
            width="135">
          </el-table-column>
          <el-table-column label="位置" min-width="140" align="left">
            <template slot-scope="scope">
              <span>{{getAddress(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="home_install_location"
            label="安装位置"
            min-width="80"
            align="left">
          </el-table-column>
        </el-table>
      </vue-seamless-scroll>
    </div>
    <div style="height: 20px;line-height: 20px;text-align: center;margin-bottom: 10px">
      <span style="cursor: pointer;color: #ffffff;font-size: 14px" @click="clickViewMore">查看更多</span>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import {querydataviewalarm} from '../../../api/alarmservice'

export default {
  name: 'alarmStatistic',
  components: { vueSeamlessScroll },
  data () {
    return {
      listData: [],
      tableData: [],

      imgIconAlarm: [],
      imgIcon: []
    }
  },
  computed: {
    classOption () {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动)
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动)
        waitTime: 500 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created () {
    this.golobleObject.getMqttNewData = this.getMqttNewData // mqtt报警过来请求接口更新
    this.imgIconAlarm = this.getImgArr.getImgIconAlarm()
    this.imgIcon = this.getImgArr.getImgIconDevice()
    this.getAlarmData()
  },
  methods: {
    // mqtt推送过来请求
    getMqttNewData (alarmObj) {
      this.getAlarmData()
    },

    getAlarmType (atype) {
      return this.commonType.getAlarmType(atype)
    },
    getTypeImgAlarm (type) {
      let num = this.commonType.getAlarmTypeIcon(type)
      return this.imgIconAlarm[num].imgUrl
    },
    getTypeImg (typeStr) {
      let type = parseInt(typeStr)
      let url = this.imgIcon[0].imgUrl
      for (let i = 0; i < this.imgIcon.length; i++) {
        if (type === this.imgIcon[i].dtype) {
          url = this.imgIcon[i].imgUrl
        }
      }
      return url
    },
    getDeviceType (typeStr) {
      let type = parseInt(typeStr)
      if (type === 700) {
        return '智能网关'
      }
      return this.commonType.getDeviceType(type)
    },
    getAddress (row) {
      let result = ''
      if (row.bulid_name && row.bulid_name !== '') {
        result += row.bulid_name
        if (row.floor_name && row.floor_name !== '') {
          result += ' / ' + row.floor_name
          if (row.home_room && row.home_room !== '') {
            result += ' / ' + row.home_room
          }
        }
      }
      return result
    },
    clickViewMore () {
      this.$router.push({path: '/eventMonitor'})
      let obj = {
        type: 'path',
        path: '/eventMonitor',
        monitor: false
      }
      this.golobleObject.getChangeLevel2(obj) // home.vue
    },

    getAlarmData () {
      this.listData = []
      this.tableData = []
      querydataviewalarm().then(res => {
        let arr = res.data.dataviewalarm
        this.listData = arr.slice(0, 4)
        this.tableData = arr.slice(4, arr.length)
      })
    },

    cellStyle ({row, column, rowIndex, columnIndex}) {
      return 'border-color:#1a1a1a!important;font-weight:bold!important'
    },
    getBackgroundColor () {
      return {backgroundColor: '#13213a', color: '#00ffff', borderColor: '#1a1a1a'}
    },
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    }
  }
}
</script>

<style>
  .el-table .warning-row {
    background: #051230;
    color: #dadada;
  }

  .el-table .success-row {
    background: #111a32;
    color: #dadada;
  }
</style>
<style scoped>
  .list-top-info{
    width: 210px;
    height: 110px;
    margin: auto;
    background: url("../../../assets/SHscreen/index_information_bg.png");
    background-size: 100% 100%;
  }
  .left-img{
    float: left;
    width: 50px;
    margin-top: 15px;
    margin-left: 15px;
    height: 85px;
  }
  .left-img img {
    width: 50px;
    height: 60px;
    margin-top: 12px;
  }
  .right-info{
    float: left;
    width: 125px;
    margin-top: 10px;
    margin-left: 5px;
    height: 90px;
  }
  .icon-left{
    float: left;
    width: 20px;
    height: 22px;
  }
  .icon-left img{
    width: 14px;
    height: 14px;
  }
  .text-right{
    font-size: 12px;
    color: white;
    width: calc(100% - 20px);
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
    height: 18px;
  }
  .no-alarm{
    height: 75px;
    width: 120px;
    background: url("../../../assets/SHscreen/index_no_information_img.png");
    background-size: 100% 100%;
    margin: auto;
  }
  .no-alarm1{
    margin-top: 5px;
    height: 20px;
    font-size: 14px;
    color: #00aaff;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitoring/dataScreenComponents/alarmStatistic.vue